var map = {
	"./check.svg": "61fa",
	"./copy.svg": "c038",
	"./dustbin.svg": "3ea4",
	"./focus.svg": "3604",
	"./format.svg": "3ecc",
	"./redo.svg": "9e78",
	"./run.svg": "ee09",
	"./save.svg": "7aa0",
	"./select_all.svg": "c40f",
	"./stop.svg": "a455",
	"./submit.svg": "edb8",
	"./theme.svg": "8e3b",
	"./tips.svg": "20d0",
	"./undo.svg": "e9a2",
	"./zoomin.svg": "0c47",
	"./zoomout.svg": "51ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3865";